var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaused(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_31_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0695 2.93052C13.1624 -0.976546 6.83813 -0.977133 2.93052 2.93052C-0.976546 6.83758 -0.977133 13.1619 2.93052 17.0695C6.83758 20.9765 13.1619 20.9771 17.0695 17.0695C20.9765 13.1624 20.9771 6.83817 17.0695 2.93052ZM9.99998 18.3554C5.39282 18.3554 1.6446 14.6071 1.6446 9.99998C1.6446 5.39282 5.39282 1.64464 9.99998 1.64464C14.6071 1.64464 18.3553 5.39286 18.3553 10C18.3553 14.6072 14.6071 18.3554 9.99998 18.3554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6684 6.25903C11.2148 6.25903 10.8472 6.6267 10.8472 7.08023V12.9198C10.8472 13.3734 11.2148 13.741 11.6684 13.741C12.1219 13.741 12.4896 13.3734 12.4896 12.9198V7.08023C12.4896 6.6267 12.1219 6.25903 11.6684 6.25903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33145 6.25903C7.87792 6.25903 7.51025 6.6267 7.51025 7.08023V12.9198C7.51025 13.3734 7.87792 13.741 8.33145 13.741C8.78499 13.741 9.15265 13.3734 9.15265 12.9198V7.08023C9.15265 6.6267 8.78503 6.25903 8.33145 6.25903Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaused);
export default __webpack_public_path__ + "static/media/paused.bd340489084deebdac69d1ca43974ce1.svg";
export { ForwardRef as ReactComponent };